<template>
    <ListPage :query="query" :total="total" v-loading="loading" :data="tableData" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" @search="handleSearch" @reset="resetQuery">
        <template slot="filters">
            <el-form-item label="关键词" prop="keywords">
                <el-input v-model="query.keywords" placeholder="搜索视频名称" clearable @keyup.enter.native="handleSearch" />
            </el-form-item>
        </template>
        <template slot="btns" v-if="permission('/content/tutorial/add')">
            <el-button icon="el-icon-plus" size="mini" type="primary" @click="handleAdd">
                新增视频
            </el-button>
        </template>
        <template slot="columns">
            <el-table-column label="权重" align="center" prop="weight"></el-table-column>
            <el-table-column label="视频封面" align="center">
                <template slot-scope="{ row }">
                    <img :src="row.videoCover" style="height: 100px"></img>
                </template>
            </el-table-column>
            <el-table-column label="视频名称" align="center" prop="videoName"></el-table-column>
            <el-table-column label="上传时间" align="center" prop="createTime"></el-table-column>
            <el-table-column label="操作" align="center" width="140"
                v-if="permission('/content/tutorial/edit') || permission('/content/tutorial/delete')">
                <template slot-scope="{ row }">
                    <el-link v-if="permission('/content/tutorial/edit')" :underline="false" type="primary"
                        @click="handleEdit(row)">
                        编辑
                    </el-link>
                    <el-link v-if="permission('/content/tutorial/delete')" :underline="false" type="danger"
                        @click="handleDelete(row)">
                        删除
                    </el-link>
                </template>
            </el-table-column>
        </template>
    </ListPage>
</template>

<script>
import { page, del } from "@/api/content/tutorial";
import listMixin from '@/mixins/list';
export default {
    data() {
        return {
            // 查询参数
            query: {
                keywords: "",
                pageNo: 1,
                pageSize: 10
            },
        };
    },
    mixins: [listMixin],
    mounted() {

    },
    methods: {
        search() {
            this.loading = true;
            const params = {
                ...this.query,
            };
            page(params).then(({ code, result, message }) => {
                if (code == 200) {
                    this.tableData = result.records;
                    this.total = result.total;
                } else {
                    this.$message.error(message);
                }
                this.loading = false;
            });
        },
        handleAdd() {
            this.$router.push({ path: "/content/tutorial/form" });
        },
        handleEdit(row) {
            this.$router.push({ path: "/content/tutorial/form", query: { id: row.id } });
        },
        handleDelete(row) {
            this.$confirm('确定删除该视频吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                del({ id: row.id }).then(({ code, message }) => {
                    if (code == 200) {
                        this.$message.success('删除成功!');
                        this.search();
                    } else {
                        this.$message.error(message);
                    }
                }).catch(() => { })
            });
        }
    },
};
</script>